// extracted by mini-css-extract-plugin
module.exports = {"button":"classes-module__button___334HL","avatar":"classes-module__avatar___3hgxw"};